import React from "react";
import { PortfolioProperty } from "../types/ownerPortfolio.types";

interface PortfolioInsightProps {
  property: PortfolioProperty;
}

const DIAGNOSIS_CLASS: Record<string, string> = {
  BAIXA_EXPOSICAO: "bg-[#6ea8ff]/15 text-[#6ea8ff]",
  PRECO_CARACTERISTICAS: "bg-[#d29922]/15 text-[#d29922]",
  CONSERVACAO: "bg-[#f85149]/15 text-[#f85149]",
};

function FunnelMetric({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-xl bg-[#0d1117] px-3 py-2">
      <p className="m-0 text-[0.65rem] uppercase tracking-wide text-[#6e7681]">{label}</p>
      <p className="m-0 mt-1 text-sm font-semibold text-[#f0f6fc]">{value}</p>
    </div>
  );
}

function formatCount(value: number | null): string {
  if (value === null) {
    return "—";
  }

  return value.toLocaleString("pt-BR");
}

export default function PortfolioInsight({ property }: PortfolioInsightProps) {
  const { funnel } = property;

  return (
    <div className="flex flex-col gap-3" data-testid={`portfolio-insight-${property.kenlo_property_id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <p className="m-0 text-sm font-semibold text-[#f0f6fc]">Por que este imóvel não aluga</p>
        {property.diagnosis_label && property.diagnosis && (
          <span
            className={`rounded-full px-2 py-0.5 text-[0.65rem] font-semibold ${DIAGNOSIS_CLASS[property.diagnosis]}`}
          >
            {property.diagnosis_label}
          </span>
        )}
      </div>

      <p className="m-0 text-xs text-[#8b949e]">Últimos {funnel.period_days} dias</p>

      <div className="grid grid-cols-2 gap-2">
        <FunnelMetric label="Visualizações" value={formatCount(funnel.page_views)} />
        <FunnelMetric label="Cliques" value={formatCount(funnel.schedule_clicks)} />
        <FunnelMetric label="Agendamentos" value={formatCount(funnel.schedules)} />
        <FunnelMetric label="Visitas" value={formatCount(funnel.visits)} />
        <FunnelMetric label="Propostas" value={formatCount(funnel.offers)} />
      </div>

      {!funnel.analytics_available && funnel.notice && (
        <p className="m-0 text-xs text-[#8b949e]">{funnel.notice}</p>
      )}

      {funnel.shared_listing && (
        <p className="m-0 text-xs text-[#8b949e]">
          As visitas e propostas consideram o anúncio principal.
        </p>
      )}
    </div>
  );
}
